// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1rhsI","title":"Header_title__2jxW2","left":"Header_left__21V2b","clinicName":"Header_clinicName__3xcjd"};